import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { OlPdfAcceptanceComponent } from 'src/app/components/ol-pdf-acceptance/ol-pdf-acceptance.component';
import { AceiteDigitalService } from 'src/app/services/aceite-digital.service';
import { PdfService } from 'src/app/services/pdf.service';
import { PropostaSalarialService } from 'src/app/services/proposta-salarial.service';
import { CO_STATUS_CONST } from 'src/app/utils/utils';

type State = 'loading' | 'generating' | 'success' | 'error';

@Component({
  selector: 'hr-gerar-pdf',
  templateUrl: './gerar-pdf.component.html',
  styleUrls: ['./gerar-pdf.component.scss'],
})
export class GerarPdfComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('olPdfAcceptance') olPdfAcceptance!: OlPdfAcceptanceComponent;

  state: State = 'loading';
  errorMessage = '';

  constructor(
    private propostaService: PropostaSalarialService,
    private pdfService: PdfService,
    private aceiteDigitalService: AceiteDigitalService
  ) {}

  ngOnInit(): void {
    this.propostaService.loadTemplate().subscribe();
    this.aceiteDigitalService.loadDigitalAcceptanceConfig().subscribe();
  }

  async ngAfterViewInit(): Promise<void> {
    try {
      await this.waitForComponentReady();
      this.state = 'generating';
      await this.pdfService.processAndUploadPdf(this.olPdfAcceptance, CO_STATUS_CONST.ACEITO);
      this.state = 'success';
      (window as any).PDF_GENERATION_STATUS = 'success';
    } catch (err) {
      this.state = 'error';
      this.errorMessage = err instanceof Error ? err.message : String(err);
      (window as any).PDF_GENERATION_STATUS = 'error';
      (window as any).PDF_GENERATION_ERROR = this.errorMessage;
    }
  }

  ngOnDestroy(): void {
    this.propostaService.onDestroy$.next(null);
    this.propostaService.onDestroy$.complete();
  }

  private waitForComponentReady(): Promise<void> {
    return new Promise((resolve) => {
      const MAX_WAIT_MS = 20_000;
      const RENDER_DELAY_MS = 2_000;
      let resolved = false;

      const interval = setInterval(() => {
        const ol = this.olPdfAcceptance;
        if (!ol) return;

        // If the service has a template but the component missed it due to race condition,
        // force-refresh so the component can render the PDF correctly.
        if (!ol.currentTemplate) {
          ol.refreshTemplate();
        }

        if (ol.currentTemplate && !resolved) {
          resolved = true;
          clearInterval(interval);
          setTimeout(resolve, RENDER_DELAY_MS);
        }
      }, 300);

      setTimeout(() => {
        clearInterval(interval);
        if (!resolved) {
          resolved = true;
          resolve();
        }
      }, MAX_WAIT_MS);
    });
  }
}
